import { render, staticRenderFns } from "./detailTable15.vue?vue&type=template&id=566f9d5c&scoped=true"
import script from "./detailTable15.vue?vue&type=script&lang=js"
export * from "./detailTable15.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566f9d5c",
  null
  
)

export default component.exports